<template>
  <div class="kouko_dashi">
    <!-- マップ/リスト表示 -->
    <div v-if="!$route.params.id && info">
      <img class="mainimage object-fit-img" :src="info.image">
      <!-- <p class="contentarea">{{info.title}}</p> -->
      <p class="contentarea t_left">{{info.text}}</p>
      
      <!-- タブ -->
      <div class="tab sitearea">
        <div class="tabnav">
          <router-link class="tabitem" v-bind:class="{active:isTabActive('map')}" :to="{query: {tab:'map'}}">{{tabNames[0][$route.params.lang]}}</router-link>
          <router-link class="tabitem" v-bind:class="{active:isTabActive('list')}" :to="{query: {tab:'list'}}">{{tabNames[1][$route.params.lang]}}</router-link>
        </div>
        <div class="tabcontent" v-bind:class="{active:isTabActive('map')}">
          <Map :options="map" :points="points" />
        </div>
        <div class="tabcontent" v-bind:class="{active:isTabActive('list')}">
          <list :data="points" />
        </div>
      </div>
    </div>
    
    <!-- 詳細表示 -->
    <div v-else-if="$route.params.id">
      <Slide v-if="point" :data="point" />
      <Vr v-if="vrs" :data="vrs" />
      <Address v-if="point" :data="point" />
      <DetailList v-if="points" :data="points" />
      <SubNavigation  v-if="point && info" :info="info" :point="point" />
    </div>
  </div>
</template>

<style lang="less">
  //mediaquery設定
  @screen-xs-max: 660px; //スマホ
  @screen-sm-max: 768px; //ipad
  @screen-lg-max: 1200px; //ブラウザサイズ1200px以下
  .screen-xs(@rules) {
      @media (max-width: @screen-xs-max) { @rules(); } 
  }
  .screen-sm(@rules) {
      @media (max-width: @screen-sm-max) { @rules(); }
  }
  .screen-lg(@rules) {
      @media (max-width: @screen-lg-max) { @rules(); }
  }

  .kouko_dashi {
    .mainimage{
      width: 100%;
      height: 500px;
      margin-bottom: 100px;
      object-fit: cover;
      font-family: 'object-fit: cover;';
      .screen-sm({
        margin-top: 55px;
      });
      .screen-xs({
        height: 170px;
        margin-bottom: 30px;
      });
    }
    .tab {
      margin-top: 110px !important;
      .tabnav{
        padding-bottom: 19px;
        border-bottom: 3px solid #3F698F;
        .screen-sm({
          margin: 0 -6%;
        });
        .screen-xs({
          padding-bottom: 14px;
        });
        @media (max-width: 320px) {
          font-size: 14px;
        }
      }
      .tabitem {
        margin: 0 1%;
        padding: 22px;
        background: #3F698F;
        border: 3px solid #3F698F;
        border-width: 3px 3px 0 3px;
        color:#fff;
        cursor:pointer;
        font-weight: bold;
        text-decoration: none;
        vertical-align: bottom;
        .screen-xs({
          padding: 17px;
        });
      }
      .tabitem.active {
        background: #fff;
        color:#3F698F;
        .screen-xs({
          padding: 17px;
        });
      }
      .tabcontent {
        display:none;
      }
      .tabcontent.active {
        display:inline;
      }
    }
  }
</style>

<script>
  // @ is an alias to /src
  import $ from "jquery"
  import contents_data from '@/assets/minamichita.json'
  import Map from '@/components/map.vue'
  import List from '@/components/list.vue'
  import DetailList from '@/components/detaillist.vue'
  import Slide from '@/components/slide.vue'
  import Vr from '@/components/vr.vue'
  import Address from '@/components/address.vue'
  import SubNavigation from '@/components/subnavigation.vue'

  const tabNames = [
    {
      "ja":"地図でさがす",
      "en":"Search by map"
    },
    {
      "ja":"リストでさがす",
      "en":"Search by list"
    }
  ]

  export default {
    name: 'KoukoDashi',
    components: {
      Map,
      List,
      DetailList,
      Slide,
      Vr,
      Address,
      SubNavigation
    },
    data() {
      return {
        tabNames,
        info: null,
        map: null,
        points: null, // リスト表示に使う全ポイントの配列
        point: null,  // 詳細表示に使う1つのポイントオブジェクト
        vrs: null     // 詳細表示に使うVRの配列
      }
    },
    // 2種類の経路でviewを使いまわしたときに、beforeUpdateでのデータセットがうまく動かなくなる
    // その対策にkeyを使うとmountを呼ぶようになるのでmount時にデータセットすることで対応できる
    // https://github.com/vuejs/vue-router/issues/779
    mounted() {
      //console.log("mounted")
      this.setData(this.$route.params)
    },
    // https://router.vuejs.org/guide/advanced/data-fetching.html#fetching-before-navigation
    // 初回
    beforeRouteEnter(route, redirect, next) {
      //console.log("beforeRouteEnter")
      next(vm => vm.setData(route.params))
    },
    // ページ移動時の更新
    beforeRouteUpdate (to, from, next) {
      //console.log("beforeRouteUpdate")
      this.setData(to.params)
      next()
    },
    methods: {
      // 指定したタブがアクティブかどうか
      isTabActive(tab) {
        if (this.$route.query.tab) {
          return this.$route.query.tab == tab
        }
        return tab == 'map';
      },
      // データセット
      setData(params, query) {
        //console.log("setData")
        const id = params.id
        const lang = params.lang
        const category = params.category
        
        const record = contents_data[lang][category]
        
        this.info = record.info
        this.map = record.map
        this.points = record.points
        
        this.point = this.vr = null
        if (typeof id !== 'undefined') {
          for (let i=0; i<record.points.length; ++i) {
            const p = record.points[i]
            if (p.id == id) {
              this.point = p
              this.vrs = p.vrs
              break;
            }
          }
        }
      }
    }
  }
</script>